import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { Toggles } from '../../../features-data/sub-models/toggles.model';
import { FormAlignmentsEnum } from '../../../form-master/form-master.enum';
import { LocationInfo } from '../../../geolocation-data/models/location-info.model';
import {
  IAutoCompleteOnSet,
  IAutoCompleteOptions,
} from '../../../shared/directives/auto-complete/auto-complete.interface';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { AddressFieldBuilder } from './address-field.builder';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';

@Component({
  selector: 'app-address-field',
  templateUrl: './address-field.component.html',
  styleUrls: ['./address-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [AddressFieldBuilder],
})
export class AddressFieldComponent implements OnInit, OnChanges {
  @Input() alignment: FormAlignmentsEnum;
  @Input() fieldId: string;
  @Input() e2eId: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() maxlength: number;
  @Input() condensed: boolean;
  @Input() fieldControl: AbstractControl;
  @Input() locationInfo: LocationInfo;
  @Input() accountCountry: string;
  @Input() featureToggles: Toggles;
  @Input() focusableTrigger$: Observable<void>;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() useNewDesign: boolean;

  private _autoCompleteTrackingObject: ITrackingObject;
  private _autoCompleteTrackingAction: ITrackingAction;

  autoCompleteOptions: { autoComplete: IAutoCompleteOptions };

  constructor(
    private _trackingDispatcher: TrackingDispatcher,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _addressFieldBuilder: AddressFieldBuilder
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.locationInfo ||
      changes.featureToggles ||
      changes.accountCountry
    ) {
      this.autoCompleteOptions =
        this.featureToggles &&
        this.featureToggles.isAllAccess(Toggles.KEYS.ADDRESS_AUTOCOMPLETE)
          ? {
              autoComplete: this._addressFieldBuilder.buildAutoCompleteOptions(
                this.locationInfo,
                this.accountCountry
              ),
            }
          : null;
    }

    if (changes.trackingScreenName) {
      this._autoCompleteTrackingAction = this._trackingActionBuilder.buildButtonTapped(
        'selection',
        this.trackingScreenName
      );
    }
  }

  ngOnInit() {
    this._autoCompleteTrackingObject = this._trackingObjectBuilder.buildAddress();
  }

  trackAutoCompleteSelect({ query }: IAutoCompleteOnSet) {
    this._trackingDispatcher.trackEvent(
      this._autoCompleteTrackingObject,
      this._autoCompleteTrackingAction,
      {
        query_term: query,
        nearby_addresses: false,
        row_selection: true,
        accept_loc_permissions: false,
        matched_results: -1, // we unfortunately cannot get this number very easily. spoke with @rachel.witalec
        // and she said mobile usage should provide enough insight
      }
    );
  }
}
